import { Feature } from 'models/Feature';
import { useEffect, useState } from 'react';

export function useFeatures() {
  const [features, setFeatures] = useState<Feature[]>([]);

  const checkFeature = (feature: Feature): boolean => {
    return features.includes(feature);
  };

  useEffect(() => {
    const fetchFeatures = async () => {
      setFeatures([]);
    };

    fetchFeatures();
  }, []);

  return {
    checkFeature,
  };
}
